<template>
    <div class="qksm qksm1">
        <div class="nogap">
            <h4>一、收入支出决算总体情况说明</h4>
            <p>
                2021年度收入、支出决算总计{{isMoney(T1.总计)}}万元。
                <span class="hide_pdf">
                    （去年决算数<reason type="money" classname="qksm money nullable" name="T1总计去年" v-model:value="T1.总计_last"></reason>万元）
                </span>
                与上年相比，
                <template v-if="num(T1.总计).toFixed(2)==num(T1.总计_last).toFixed(2)">
                    收、支总计各相同。
                </template>
                <template v-else>
                    收、支总计各{{growthValueText(T1.总计,T1.总计_last)}}万元
                    <template v-if="num(T1.总计_last)==0">
                        （上年决算数为0万元，无法计算增减比率）。
                    </template>
                    <template v-else>
                        ，{{growthRatioText(T1.总计,T1.总计_last)}}。
                    </template>
                </template>
                其中：
            </p>
            <p><b>(一)收入决算总计{{isMoney(T1.总计)}}万元。包括：</b></p>
            <p v-for="(item, idx) in T1.收入" :key="idx">
                {{idx+1}}.{{item.name}}{{isMoney(item.value)}}万元。
                <span class="hide_pdf">
                    （去年决算数<reason type="money" classname="qksm money nullable" :name="item.name+'去年'" v-model:value="item.lastValue"></reason>万元）
                </span>
                <template v-if="item.value==num(item.lastValue)">
                    与上年决算数相同。
                </template>
                <template v-else>
                    与上年相比，{{growthValueText(item.value, num(item.lastValue))}}万元
                    <template v-if="num(item.lastValue)==0">
                        （上年决算数为0万元，无法计算增减比率）
                    </template>
                    <template v-else>
                        ，{{growthRatioText(item.value,num(item.lastValue))}}
                    </template>
                    ，变动原因：
                    <reason type="textarea" classname="qksm widest" :name="'T1'+item.name+'原因'" v-model:value="qksm['T1'+item.name+'原因']"></reason>
                </template>
            </p>
            <p><b>(二)支出决算总计{{isMoney(T1.支出总计)}}万元。包括：</b></p>
            <p v-for="(item, idx) in T1.支出" :key="idx">
                {{idx+1}}.{{item.name}}{{isMoney(item.value)}}万元。
                <template v-if="item.name.indexOf('结余')!=-1 && num(item.value)>0">
                    {{item.name.replace("年末","")}}事项：
                    <reason type="textarea" classname="qksm widest" :name="item.name+'事项'" v-model:value="qksm[item.name+'事项']"></reason>
                </template>
                <span class="hide_pdf">
                    （去年决算数<reason type="money" classname="qksm money nullable" :name="item.name+'去年'" v-model:value="item.lastValue"></reason>万元）
                </span>
                <template v-if="item.value==num(item.lastValue)">
                    与上年决算数相同。
                </template>
                <template v-else>
                    与上年相比，{{growthValueText(item.value, num(item.lastValue))}}万元
                    <template v-if="num(item.lastValue)==0">
                        （上年决算数为0万元，无法计算增减比率）
                    </template>
                    <template v-else>
                        ，{{growthRatioText(item.value,num(item.lastValue))}}
                    </template>
                    ，变动原因：
                    <reason type="textarea" classname="qksm widest" :name="'T1'+item.name+'原因'" v-model:value="qksm['T1'+item.name+'原因']"></reason>
                </template>
            </p>
        </div>
    </div>
</template>
<script>
    import reason from "@/components/reason.vue";
    export default {
        name: "qksm1",
        data() {
            var qksm = this.$store.state.divData.qksm;
            if (qksm['T1总计去年'])
                this.T1['总计_last'] = qksm['总计去年'];
            for (let item of this.T1.收入) {
                item.lastValue = this.pickOneOf(qksm[item.name + '去年'], item.lastValue )
            }
            for (let item of this.T1.支出) {
                item.lastValue = this.pickOneOf(qksm[item.name + '去年'], item.lastValue)
            }
            return {
                isPdf: this.$parent.isPdf,
                qksm: qksm,
            }
        },
        props: {
            T1: {
                type: Object,
                default: "",
            },
        },
        components: {
            reason,
        }
    };
</script>